import * as React from "react";

const FilterIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 0 48 48" width="48">
            <path d="m0 0h48v48h-48z" fill="none" />
            <path
                d="m41.8 8h-20.1a6.2 6.2 0 0 0 -5.7-4 6 6 0 0 0 -5.6 4h-4.2a2.1 2.1 0 0 0 -2.2 2 2.1 2.1 0 0 0 2.2 2h4.2a6 6 0 0 0 5.6 4 6.2 6.2 0 0 0 5.7-4h20.1a2.1 2.1 0 0 0 2.2-2 2.1 2.1 0 0 0 -2.2-2z"
                fill="white"
            />
            <path
                d="m41.8 22h-4.1a6.2 6.2 0 0 0 -5.7-4 6 6 0 0 0 -5.6 4h-20.2a2 2 0 1 0 0 4h20.2a6 6 0 0 0 5.6 4 6.2 6.2 0 0 0 5.7-4h4.1a2 2 0 1 0 0-4z"
                fill="white"
            />
            <path
                d="m41.8 36h-17.1a6.2 6.2 0 0 0 -5.7-4 6 6 0 0 0 -5.6 4h-7.2a2 2 0 1 0 0 4h7.2a6 6 0 0 0 5.6 4 6.2 6.2 0 0 0 5.7-4h17.1a2 2 0 1 0 0-4z"
                fill="white"
            />
        </svg>
    );
};

export default React.memo(FilterIcon);
